import React, { useEffect } from 'react'
import HeaderSec from '../../HeaderSec/HeaderSec'
import FooterComp from '../FooterComp'
import FooterSecComp from '../FooterSecComp'
import { Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import feedback from '../../../Assets/img/Send Feedback.png'


const Feedback = () => {
    useEffect(() => {
            window.scrollTo(0, 0);
        }, []);
    const section1 = [
        'Namaste! ',
        'At GuideStar India, we are keen to hear from you, our users! We know that for every person who speaks, there could be several others who felt the same way but did not voice their view, comment, suggestion or question! Your voice will help us serve you and the unspoken others better!',
        'We speak English, Hindi, Marathi, Konkani, Gujarati, Bengali, Tamil and Malayalam! Using translation tools and with help from our NPO partners, we can read your communication in most Indian languages! Let language not be a barrier! Just write to us and should your message require a response, you could expect to hear from us within 2 working days.',
        ''
    ]
  return (
    <div className='max-w-screen overflow-hidden text-black'>
        <HeaderSec/>
        <div className='max-w-[1200px] m-auto min-h-[500px]'>
            <FooterSecComp
                topic={"Feedback"}
                section={section1}
                image={feedback}
            />
            <Typography variant='h3'  sx={{fontSize:'15px' , fontWeight:400 , margin:' 0 0 10px 0' , textAlign:'justify' , lineHeight:1.6}}>
                Please write to us at: <Link to='/contact' className='text-blue-600'>Contact Us!</Link>  You could also call or WhatsApp on <a href="https://wa.me/918356832329" target="_blank" rel="noopener noreferrer" className='text-blue-600'>+91-8356832329</a>  
            </Typography>
        </div>

        <FooterComp/>
    </div>
  )
}

export default Feedback